module.exports = __webpack_public_path__ + "static/SoinSansNeue-Medium-421ac161fe031f73b47f52fa16326389.otf";